import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Singapore Company Formation',
        link: '/singapore-company-formation',
    },
]

function CompanyFormationSeychelles() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Company Formation in Seychelles</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate Your International Business Company (IBC) in Seychelles</h3>
                            <p className='page-paragraph'>
                                <b>Seychelles</b> is one of the most popular <b>offshore jurisdictions</b> for <b>entrepreneurs, traders, and asset holders</b>. With its <b>cost-efficient incorporation</b>, <b>0% corporate tax on offshore income</b>, and <b>strong confidentiality laws</b>, Seychelles is a leading choice for <b>international business structures</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Fast Incorporation",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "0% Tax",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Confidential Shareholding",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Cost-Efficient",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Seychelles Company Formation Consultation →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in Seychelles?</h3>
                        <PageList
                            items={[
                                {
                                    title: "0% Corporate Tax",
                                    paragraph: "On foreign-sourced income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Incorporation",
                                    paragraph: "IBC setup in 1–3 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimal Reporting",
                                    paragraph: "No annual return or financial reporting for IBCs (unless engaged locally)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Full Foreign Ownership",
                                    paragraph: "No local partner required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection",
                                    paragraph: "Strong confidentiality and protection of shareholder/beneficial ownership",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Cost Efficiency",
                                    paragraph: "One of the lowest-priced offshore setups",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Companies in Seychelles</h3>
                        <PageList
                            items={[
                                {
                                    title: "International Business Company (IBC)",
                                    paragraph: "Most common offshore entity, flexible and tax-exempt",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Special License Company (CSL)",
                                    paragraph: "Used for businesses seeking double tax treaty benefits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Trusts & Foundations",
                                    paragraph: "Available for estate planning and asset protection",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Key Features of Seychelles IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "Minimum Share Capital",
                                    paragraph: "No minimum requirement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "At least 1 (individual or corporate, can be foreign)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Shareholders",
                                    paragraph: "At least 1 (can be foreign, nominee allowed)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Secretary",
                                    paragraph: "Not mandatory",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Accounting",
                                    paragraph: "Required to maintain records, but no filing with authorities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality",
                                    paragraph: "Beneficial ownership not publicly disclosed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Taxation",
                                    paragraph: "0% tax for offshore income; local income subject to standard rates",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Choose Company Name & Structure",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Prepare Due Diligence & KYC Documents",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "File Incorporation Documents with Seychelles FSA",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Receive Certificate of Incorporation",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Open Offshore Bank Account",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p><b>Timeline: </b>1–3 business days for IBC registration.</p>

                        <h3 className='page-title'>Common Uses of Seychelles Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "International Trade & Commerce",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Holding Company for Investments or Subsidiaries",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Crypto & FinTech Startups",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection & Wealth Management",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidential Business Structures",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />
                    <CTA
                        title="Ready to register your Seychelles company?"
                        description=
                            "Offshore Advisory provides fast <b>IBC incorporation, nominee</b> services, and global bank account assistance."
                        buttonText="Book a Free Consultation for Seychelles Company Formation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default CompanyFormationSeychelles

const faqData = [
    {
        question: "How long does it take to incorporate in Seychelles?",
        content: [
            { type: "answer", text: "1–3 business days." },
        ],
    },
    {
        question: "Are Seychelles companies tax-free?",
        content: [
            { type: "answer", text: "Yes, offshore income is exempt from tax." },
        ],
    },
    {
        question: "Do Seychelles companies need audited accounts?",
        content: [
            { type: "answer", text: "No, unless conducting local business." },
        ],
    },
    {
        question: "Can Seychelles IBCs open international bank accounts?",
        content: [
            { type: "answer", text: "Yes, they are widely accepted for offshore banking." },
        ],
    },
    {
        question: "Is confidentiality guaranteed?",
        content: [
            { type: "answer", text: "Yes, shareholder and beneficial owner details are protected." },
        ],
    },
];


